module.exports = __webpack_public_path__ + "img/avatar.9bb27c7b.svg";